<odx-content-box
  class="content-box flex-column"
  odxLayout="flex gap-none"
  [ngClass]="{
    selected: quantity() > 0,
  }"
  (click)="onCardClicked()"
>
  <odx-area-header class="header">
    <h6
      class="odx-title-6 card-title"
      [odxTooltip]="attachment() | localizeProductName"
      [odxTooltipDisabled]="isTooltipDisabled()"
      odxTooltipSize="large"
    >
      {{ attachment() | localizeProductName }}
    </h6>
  </odx-area-header>
  <div class="h-100 content">
    <!-- prettier-ignore-attribute style -->
    <div class="image-wrapper">
      @if (true) {
        <odx-icon name="picture"></odx-icon>
      }
    </div>
    @if (attachment().id) {
      <div class="feature">
        <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
        <p class="odx-text--small">{{ attachment().id }}</p>
      </div>
    }
    <form odxForm>
      <odx-form-field i18n-label="@@global.quantity" label="Anzahl">
        <odx-spinbox
          odxFormFieldControl
          name="quantity"
          [ngModel]="quantity()"
          (click)="$event.stopPropagation()"
          (ngModelChange)="onQuantityChanged($event)"
          [min]="0"
          [max]="isGuide() ? 1 : Infinity"
          [step]="1"
        ></odx-spinbox>
      </odx-form-field>
    </form>
  </div>
  <odx-content-box-footer class="footer w-100">
    <div odxLayout="flex" class="space-between">
      <!-- do not propagate radio button click to prevent from multiple click events when card is clicked -->
      @if (selectionMode() === "single") {
        <odx-radio-button (click)="$event.stopPropagation()" [value]="attachment()" i18n="@@global.select"
          >Auswählen</odx-radio-button
        >
      }

      <!-- do not propagate checkbox click to prevent from multiple click events when card is clicked -->
      @if (selectionMode() === "multi") {
        <odx-checkbox
          (click)="$event.stopPropagation()"
          [checked]="quantity() > 0"
          (checkedChange)="onCheckedChanged($event)"
          #checkboxAttachment
          i18n="@@global.select"
          >Auswählen</odx-checkbox
        >
      }
      <p>{{ showCosts() && priceData() ? (priceData()!.price | currency: priceData()!.currencyCode) : "" }}</p>
    </div>
  </odx-content-box-footer>
</odx-content-box>
